import request from '@/utils/request'

let PackageApi = {

  /*vip套餐列表*/
  list(data) {
    return request._post('/shop/plus.vip_package.Index/index', data);
},
/*添加vip套餐*/
add(data) {
    return request._post('/shop/plus.vip_package.Index/add', data);
},
/*修改vip套餐*/
edit(data) {
    return request._post('/shop/plus.vip_package.Index/edit', data);
},
/*删除vip套餐*/
del(data) {
    return request._post('/shop/plus.vip_package.Index/del', data);
},
/*vip套餐详情*/
detail(data) {
  return request._post('/shop/plus.vip_package.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.vip_package.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.vip_package.Setting/getSetting', data, errorback);
    },
    






    
}
export default PackageApi;



// WEBPACK FOOTER //
// ./src/api/package.js